import React, { useState } from 'react';
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom';
import AdminHome from './AdminHome';
import ManageCows from './ManageCows';
import ManageDonations from './ManageDonations';
import ManageExpenses from './ManageExpenses';
import ManageGallery from './ManageGallery';
import ManageMilk from './ManageMilk';
import FinancialReport from './FinancialReport';
import ManageContent from './ManageContent';
import ManageManagement from './ManageManagement';
import ManageDonationWays from './ManageDonationWays';
import Visitors from './Visitors';
import ManageSiteContent from './ManageSiteContent';
import ManageMenu from './ManageMenu';
import ManageCattleBreeds from './ManageCattleBreeds';
import ManageVideos from './ManageVideos';
import ManageChatbot from './ManageChatbot';
import PaymentSettings from './PaymentSettings';

const NAV = [
  { path: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { path: '/admin/visitors', label: 'Visitors', icon: '🌍' },
  { path: '/admin/cows', label: 'Manage Cows', icon: '🐂' },
  { path: '/admin/donations', label: 'Donations', icon: '💰' },
  { path: '/admin/expenses', label: 'Expenses', icon: '📋' },
  { path: '/admin/milk', label: 'Milk Records', icon: '🥛' },
  { path: '/admin/gallery', label: 'Gallery', icon: '📸' },
  { path: '/admin/videos', label: 'Videos', icon: '🎥' },
  { path: '/admin/management', label: 'Management', icon: '🙏' },
  { path: '/admin/breeds', label: 'Indian Breeds', icon: '🐂' },
  { path: '/admin/donation-ways', label: 'Donation Ways', icon: '🎁' },
  { path: '/admin/site-content', label: 'Site Content', icon: '🖼️' },
  { path: '/admin/menu', label: 'Menu', icon: '🧭' },
  { path: '/admin/content', label: 'Content (FAQ/Slokas)', icon: '📝' },
  { path: '/admin/financial', label: 'Financial Report', icon: '📈' },
  { path: '/admin/chatbot', label: 'Chatbot', icon: '💬' },
  { path: '/admin/settings', label: 'Payment Settings', icon: '⚙️' },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h3>🐂 Goshala Admin</h3>
          <div className="admin-sidebar-user">
            <div className="admin-sidebar-user-avatar">{(adminUser.name || 'A').charAt(0).toUpperCase()}</div>
            <div className="admin-sidebar-user-info">
              <div className="admin-sidebar-user-name">{adminUser.name || 'Admin'}</div>
              <div className="admin-sidebar-user-role">{adminUser.role === 'superadmin' ? 'Super Admin' : 'Admin'}</div>
            </div>
          </div>
        </div>
        <nav className="admin-nav">
          {NAV.map(item => (
            <NavLink key={item.path} to={item.path} end={item.end} className={({ isActive }) => `admin-nav-item${isActive ? ' active' : ''}`}>
              <span>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
          <div className="admin-nav-item" onClick={handleLogout} style={{ marginTop: 16, color: '#e57373', cursor: 'pointer' }}>
            <span>🚪</span><span>Logout</span>
          </div>
        </nav>
        <div style={{ padding: '12px 24px', color: '#555', fontSize: '0.75rem', borderTop: '1px solid #333', marginTop: 'auto' }}>
          <a href="/" style={{ color: '#777' }}>← View Website</a>
        </div>
      </aside>

      <main className="admin-content">
        <Routes>
          <Route path="/" element={<AdminHome />} />
          <Route path="/visitors" element={<Visitors />} />
          <Route path="/cows" element={<ManageCows />} />
          <Route path="/donations" element={<ManageDonations />} />
          <Route path="/expenses" element={<ManageExpenses />} />
          <Route path="/milk" element={<ManageMilk />} />
          <Route path="/gallery" element={<ManageGallery />} />
          <Route path="/videos" element={<ManageVideos />} />
          <Route path="/management" element={<ManageManagement />} />
          <Route path="/breeds" element={<ManageCattleBreeds />} />
          <Route path="/donation-ways" element={<ManageDonationWays />} />
          <Route path="/site-content" element={<ManageSiteContent />} />
          <Route path="/menu" element={<ManageMenu />} />
          <Route path="/content" element={<ManageContent />} />
          <Route path="/financial" element={<FinancialReport />} />
          <Route path="/chatbot" element={<ManageChatbot />} />
          <Route path="/settings" element={<PaymentSettings />} />
        </Routes>
      </main>
    </div>
  );
}
